/* Mobiler Konfigurator „Dock“ (Marc, 2026-10-06).

   Sofa groß, darunter zwei schmale Reihen statt einer 3.600 px langen Liste:
   Reihe 1 = Stoffarten als Chips (zuerst „★ Bestseller“, bei aktivem Filter
   „Alle Treffer · N“), Reihe 2 = Farben des gewählten Stoffs. Filter öffnen als
   Bottom-Sheet; bei vielen Treffern gibt es ein Raster über der Kaufleiste.

   Greift nur ≤ 989 px. Baut auf dem bestehenden Mobil-Arbeitsbereich
   (fmnv-p3d-mobile-test.js) auf und nutzt dessen Filter-Elemente — hier wird
   nur umgestellt, nicht neu gefiltert. Das CSS (fmnv-p3d-layouts.css) hängt an
   html.fmnv-lay.fmnv-lay-f. ?layout=0 schaltet für die Sitzung auf das alte
   Layout zurück (Vergleich/Fehlersuche), ?layout=f wieder ein. Ab 990 px gilt
   seit 2026-10-08 das Desktop-Layout (deskStart); ?layout=0 schaltet auch das ab. */
(function () {
  var desk = !matchMedia('(max-width: 989px)').matches;
  var aus = false;
  try {
    var q = new URLSearchParams(location.search).get('layout');
    if (q === '0') sessionStorage.setItem('fmnvLayAus', '1');
    else if (q) sessionStorage.removeItem('fmnvLayAus');
    aus = sessionStorage.getItem('fmnvLayAus') === '1';
  } catch (e) { aus = new URLSearchParams(location.search).get('layout') === '0'; }
  if (aus) return;
  var html = document.documentElement;
  if (desk) {
    if (document.readyState !== 'loading') deskWarte(); else document.addEventListener('DOMContentLoaded', deskWarte);
    return;
  }
  html.classList.add('fmnv-lay', 'fmnv-lay-f');

  /* Messung wie im Konfigurator (melde in fmnv-p3d-main.js): GA bekommt
     fmnv_konfigurator mit fmnv_aktion = dock_*; Stoff/Farbe aus der Auswahl. */
  function melde(aktion, detail, root) {
    try {
      var sa = window.Shopify && window.Shopify.analytics;
      if (!sa || typeof sa.publish !== 'function') return;
      var sel = (root && root.dataset.mobileSelection || '').split(' · ');
      var m = location.pathname.match(/\/products\/([^/?#]+)/);
      sa.publish('fmnv:konfigurator', {
        aktion: aktion, detail: String(detail == null ? '' : detail).slice(0, 90),
        produkt: m ? m[1] : '', stoff: sel[0] || '', farbe: sel[1] || '',
      });
    } catch (e) { /* Messung darf die Bedienung nie stören */ }
  }

  function start(root) {
    // Ankündigungsleiste (erste Kopfgruppe) weg — der Platz gehört dem Sofa.
    var groups = document.querySelectorAll('.shopify-section-group-header-group');
    if (groups[0]) groups[0].classList.add('fmnv-lay-ann');

    /* Preis in den Warenkorb-Knopf (einzeilige Kaufleiste). Quelle ist der
       Kaufleisten-Preis [data-p3d-price]; .fmnv-p3d__price allein träfe den
       „Preis ab“ des alten Schaufensters und zeigte bei Aufpreis-Stoffen den
       Grundpreis (QA 2026-10-06). */
    var preisEl = root.querySelector('[data-p3d-price]') || root.querySelector('.fmnv-p3d__buy .fmnv-p3d__price');
    var atcText = root.querySelector('.fmnv-p3d__buy .fmnv-p3d__atc-text');
    function preis() {
      if (!preisEl || !atcText) return;
      atcText.setAttribute('data-preis', preisEl.textContent.replace(/\s+/g, ' ').replace(',00', '').trim());
    }
    if (preisEl) { preis(); new MutationObserver(preis).observe(preisEl, { childList: true, characterData: true, subtree: true }); }

    /* Shopify-Vorschaubalken (nur in Test-Themes vorhanden): Platz freihalten */
    (function () {
      var n = 0, t = setInterval(function () {
        var f = document.getElementById('PBarNextFrame');
        if (f || ++n > 40) {
          clearInterval(t);
          if (f) { html.style.setProperty('--lay-preview', '64px'); setTimeout(function () { dispatchEvent(new Event('resize')); }, 60); }
        }
      }, 250);
    })();
    dock(root);
    wischen(root);
    modell(root);
    setTimeout(function () { dispatchEvent(new Event('resize')); }, 60);
  }

  function dock(root) {
    var body = root.querySelector('[data-p3d-step="2"] .fmnv-p3d__step-body');
    var liste = root.querySelector('.fmnv-p3d__sflist');
    if (!body || !liste) return;
    var dockEl = document.createElement('div'); dockEl.className = 'lay-dock';
    var chips = document.createElement('div'); chips.className = 'lay-chips'; chips.setAttribute('role', 'tablist'); chips.setAttribute('aria-label', 'Stoffart');
    var info = document.createElement('div'); info.className = 'lay-info';
    var txt = document.createElement('span');
    /* Bestseller wie jede andere Stoffart (Marc, 2026-10-08): vorn die große Probe des gewählten Stoffs
       mit Lupe darauf, daneben die runden Farben. Ersetzt den Knopf „Stoff groß ansehen“. */
    var bsProbe = document.createElement('div'); bsProbe.className = 'lay-bs-probe';
    var bsLupe = document.createElement('button'); bsLupe.type = 'button'; bsLupe.className = 'fmnv-p3d__sf-zoom';
    bsLupe.innerHTML = '<svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M15.5 15.5L20 20M10.5 7.5v6M7.5 10.5h6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    bsProbe.appendChild(bsLupe);
    var bsBlock = root.querySelector('.fmnv-p3d__bs'); if (bsBlock) bsBlock.insertBefore(bsProbe, bsBlock.firstChild);
    var fsum = document.createElement('div'); fsum.className = 'lay-fsum'; fsum.hidden = true;
    info.append(txt); dockEl.append(chips, fsum, info); body.insertBefore(dockEl, body.firstChild);
    var aktiv = 'bs';
    function reihen() { return [].slice.call(liste.querySelectorAll('.fmnv-p3d__sf')); }
    function name(z) { return z._familie ? z._familie.name : ''; }
    function farbenZahl() { return liste.querySelectorAll('.fmnv-p3d__sf-color').length; }
    function sync() {
      body.classList.toggle('lay-bs-aktiv', aktiv === 'bs');
      body.classList.toggle('lay-flat-aktiv', aktiv === 'flat');
      reihen().forEach(function (z) {
        z.classList.toggle('lay-aktiv', aktiv !== 'bs' && aktiv !== 'flat' && name(z) === aktiv);
        // Unterschrift in der Treffer-Reihe: dort mischen sich die Stoffe.
        z.querySelectorAll('.fmnv-p3d__sf-color').forEach(function (b) { b.dataset.fam = name(z); });
      });
      [].forEach.call(chips.children, function (c) { c.classList.toggle('ist-an', c.dataset.k === aktiv); c.setAttribute('aria-selected', String(c.dataset.k === aktiv)); });
      var sel = root.dataset.mobileSelection;
      txt.innerHTML = sel ? '<b>' + sel.replace(/</g, '&lt;') + '</b>' : 'Tippe eine Farbe an';
      // Probe der Bestseller-Reihe = gewählter Stoff in der gewählten Farbe (wie die Probe einer Stoffzeile).
      var gz = gewaehlteZeile(), gi = gz && gz.querySelector('.fmnv-p3d__sf-img');
      bsProbe.style.backgroundImage = gi ? gi.style.backgroundImage : '';
      bsLupe.setAttribute('aria-label', (gz ? name(gz) : 'Stoff') + ' im Vollbild zeigen');
      filterStand();
    }
    function bauen() {
      chips.innerHTML = '';
      var fb = document.createElement('button'); fb.type = 'button'; fb.className = 'lay-chip lay-chip--filter'; fb.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M4 7h10M18 7h2M4 17h4M12 17h8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="16" cy="7" r="2.2" fill="none" stroke="currentColor" stroke-width="2"/><circle cx="10" cy="17" r="2.2" fill="none" stroke="currentColor" stroke-width="2"/></svg>Farbfilter <span class="lay-n" hidden></span>';
      fb.addEventListener('click', function () {
        raster(false);
        var tg = root.querySelector('.p3dm-filter-toggle'); if (tg) tg.click();
        melde('dock_filter_offen', '', root);
      });
      chips.appendChild(fb);
      var treffer = aktiveFilter().length ? [['flat', 'Alle Treffer · ' + farbenZahl()]] : [];
      var neu = [['bs', '★ Bestseller']].concat(treffer, reihen().map(function (z) {
        return [name(z), name(z) + (treffer.length ? ' · ' + z.querySelectorAll('.fmnv-p3d__sf-color').length : '')];
      }));
      if (aktiv !== 'bs' && !neu.some(function (n) { return n[0] === aktiv; })) aktiv = treffer.length ? 'flat' : 'bs';
      neu.forEach(function (n) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'lay-chip'; b.dataset.k = n[0]; b.textContent = n[1]; b.setAttribute('role', 'tab');
        b.addEventListener('click', function () {
          aktiv = n[0]; raster(false); sync();
          // Kein scrollIntoView: das rollte die Seite weg, wenn gerade das Raster zuging.
          chips.scrollTo({ left: Math.max(0, b.offsetLeft - (chips.clientWidth - b.offsetWidth) / 2), behavior: 'smooth' });
          melde('dock_stoff', n[0], root);
        });
        chips.appendChild(b);
      });
      sync();
    }
    // Groß gezeigt wird der gewählte Stoff; ohne Wahl der gerade offene.
    function gewaehlteZeile() {
      return reihen().filter(function (r) { return r.classList.contains('is-current'); })[0]
        || reihen().filter(function (r) { return r.classList.contains('lay-aktiv'); })[0] || reihen()[0];
    }
    bsLupe.addEventListener('click', function () {
      var z = gewaehlteZeile(), zoom = z && z.querySelector('.fmnv-p3d__sf-zoom'); if (zoom) zoom.click();
      melde('dock_lupe', '', root);
    });
    function aktiveFilter() {
      return [].slice.call(root.querySelectorAll('.fmnv-p3d__sffilter .fmnv-p3d__mood.is-active, .fmnv-p3d__sffilter .fmnv-p3d__fabchip.is-active, .fmnv-p3d__sffilter [aria-checked="true"]'));
    }
    function filterNamen(a) { return a.map(function (b) { return b.textContent.replace('Zurücksetzen', '').trim(); }).filter(Boolean); }

    /* Raster: alle Treffer als 5-Spalten-Sheet über der Kaufleiste, das Sofa bleibt sichtbar. */
    var rKopf = document.createElement('div'); rKopf.className = 'lay-raster-kopf';
    rKopf.innerHTML = '<b></b><button type="button">Fertig</button>'; document.body.appendChild(rKopf);
    rKopf.querySelector('button').addEventListener('click', function () { raster(false); });
    function raster(an) {
      var buy = root.querySelector('.fmnv-p3d__buy');
      if (buy) root.style.setProperty('--lay-buy', Math.round(buy.getBoundingClientRect().height) + 'px');
      body.classList.toggle('lay-raster-offen', !!an && aktiv === 'flat');
      var offen = body.classList.contains('lay-raster-offen');
      // Solange ein Sheet offen ist, bleibt die Seite dahinter stehen.
      html.classList.toggle('lay-lock', offen || root.classList.contains('p3dm-filters-open'));
      rKopf.classList.toggle('ist-offen', offen);
      rKopf.firstChild.textContent = 'Alle ' + farbenZahl() + ' Treffer';
      if (offen) { var a = liste.querySelector('.fmnv-p3d__sf-color.is-active'); if (a) a.scrollIntoView({ block: 'center' }); }
    }
    var hatFilter = false;
    function filterStand() {
      var a = aktiveFilter();
      if (!!a.length !== hatFilter) {
        // Filter kommt oder geht: in die Treffer-Ansicht bzw. zurück zu den Bestsellern.
        hatFilter = !!a.length; aktiv = hatFilter ? 'flat' : (aktiv === 'flat' ? 'bs' : aktiv);
        if (hatFilter) melde('dock_filter', filterNamen(a).join(', '), root);
        bauen(); return;
      }
      var n = chips.querySelector('.lay-n'); if (n) { n.hidden = !a.length; n.textContent = a.length; }
      if (a.length) {
        var farben = farbenZahl();
        var namen = a.length <= 2 ? filterNamen(a).join(', ') : a.length + ' Filter';
        fsum.hidden = false;
        fsum.innerHTML = '<span>' + namen.replace(/</g, '&lt;') + ' · ' + farben + ' Farben</span>';
        var bt = document.createElement('span'); bt.className = 'lay-fsum-btns';
        if (farben > 8) {
          var r = document.createElement('button'); r.type = 'button'; r.textContent = '⊞ Raster';
          r.addEventListener('click', function () { aktiv = 'flat'; sync(); raster(true); melde('dock_raster', farben, root); });
          bt.appendChild(r);
        }
        var z = document.createElement('button'); z.type = 'button'; z.textContent = 'Zurücksetzen';
        z.addEventListener('click', function () { aktiveFilter().forEach(function (b) { b.click(); }); melde('dock_filter_reset', '', root); });
        bt.appendChild(z); fsum.appendChild(bt);
      } else fsum.hidden = true;
    }
    var fl = root.querySelector('.fmnv-p3d__sffilter');
    if (fl) new MutationObserver(filterStand).observe(fl, { attributes: true, subtree: true, attributeFilter: ['class', 'aria-checked'] });
    var back = document.createElement('div'); back.className = 'lay-backdrop'; back.hidden = true; document.body.appendChild(back);
    back.addEventListener('click', function () { var ap = root.querySelector('.p3dm-filter-apply'); if (ap) ap.click(); });
    new MutationObserver(function () {
      var f = root.classList.contains('p3dm-filters-open'); back.hidden = !f;
      html.classList.toggle('lay-lock', f || body.classList.contains('lay-raster-offen'));
    }).observe(root, { attributes: true, attributeFilter: ['class'] });
    // Der Konfigurator baut die Liste bei Filter-/Ausführungswechsel neu — Chips folgen.
    new MutationObserver(function () { bauen(); }).observe(liste, { childList: true });
    new MutationObserver(function () { sync(); }).observe(root, { attributes: true, attributeFilter: ['data-mobile-selection'] });
    /* Über die letzte Farbe hinaus wischen = nächster Stoff (Marc, 2026-10-21).
       Zählt nur, wenn die Reihe schon beim Aufsetzen am Ende stand — sonst scrollt der Wisch erst. */
    var ueber = null;
    body.addEventListener('touchstart', function (e) {
      var r = e.target.closest('.fmnv-p3d__sf.lay-aktiv .fmnv-p3d__sf-colors, .lay-bs-aktiv .fmnv-p3d__bs-row');
      ueber = r && e.touches.length === 1 && r.scrollLeft + r.clientWidth >= r.scrollWidth - 2
        ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : null;
    }, { passive: true });
    body.addEventListener('touchend', function (e) {
      if (!ueber) return;
      var t = e.changedTouches[0], dx = t.clientX - ueber.x, dy = t.clientY - ueber.y;
      ueber = null;
      if (dx > -50 || Math.abs(dx) < 1.5 * Math.abs(dy)) return;
      var an = chips.querySelector('.lay-chip.ist-an'), next = an && an.nextElementSibling;
      if (next) { next.click(); melde('dock_ueberwischen', next.dataset.k, root); }
    }, { passive: true });
    bauen();
  }

  /* Schritt „Modell“ wie das Formen-Blatt der Kollektion (Marc, 2026-10-06): je Form
     eine Zeile mit Vorschaubild, Name, Breite × Tiefe und „ab“-Preis; die gewählte
     Zeile ist umrandet und trägt darunter Seite/Funktion. Die Zeilen klicken die
     vorhandenen Form-Knöpfe — Logik und Preise bleiben im Konfigurator. */
  function modell(root) {
    var body = root.querySelector('[data-p3d-step="1"] .fmnv-p3d__step-body');
    var axis = root.querySelector('[data-p3d-axis-size]');
    if (!body || !axis) return;
    var formGroup = axis.closest('.fmnv-p3d__axisgroup'); if (formGroup) formGroup.setAttribute('data-lay-form-axis', '');
    var seite = root.querySelector('[data-p3d-seite-group]'), sleep = root.querySelector('[data-p3d-sleep-group]');
    var liste = document.createElement('div'); liste.className = 'lay-formen'; liste.setAttribute('role', 'radiogroup'); liste.setAttribute('aria-label', 'Form');
    body.insertBefore(liste, body.firstChild);
    var opts = document.createElement('div'); opts.className = 'lay-form-opts';
    if (seite) opts.appendChild(seite); if (sleep) opts.appendChild(sleep);
    var D = {}; try { D = JSON.parse(document.querySelector('[data-p3d-daten]').textContent); } catch (e) {}
    var cfgs = D.configs || [];
    var cssLink = document.querySelector('link[href*="fmnv-p3d-layouts.css"]');
    var base = cssLink ? cssLink.href.split('fmnv-p3d-layouts.css')[0] : '';
    function masse(k) {
      var m = {}; String(k && k.masse || '').split(';').forEach(function (t) { var p = t.split('|'); if (p[1]) m[p[0].trim()] = p[1].trim(); });
      return m['Breite'] && m['Tiefe'] ? m['Breite'].replace(/\s*cm$/, '') + ' × ' + m['Tiefe'] : (m['Breite'] || '');
    }
    function aktuelleSeite() { var b = seite && seite.querySelector('.fmnv-p3d__cfg.is-active'); return b ? (/rechts/i.test(b.textContent) ? 'rechts' : 'links') : ''; }
    function bild(name) {
      var s = aktuelleSeite();
      var k = cfgs.filter(function (c) { return c.name === name; });
      var t = k.filter(function (c) { return !c.schlaf && (!s || (c.seite || '') === s || !c.seite); })[0] || k[0];
      return t ? { url: base + 'fmnv-preview-' + t.handle + '.png', masse: masse(t) } : { url: '', masse: '' };
    }
    function bauen() {
      var knoepfe = [].slice.call(axis.querySelectorAll('.fmnv-p3d__cfg'));
      liste.innerHTML = '';
      knoepfe.forEach(function (b) {
        var name = (b.querySelector('strong') || b).textContent.trim();
        var preis = ((b.querySelector('em') || {}).textContent || '').replace(/,00/, '').replace(/\s+/g, ' ').trim();
        var an = b.classList.contains('is-active'), info = bild(name);
        var w = document.createElement('div'); w.className = 'lay-formwrap' + (an ? ' ist-gewaehlt' : '');
        var r = document.createElement('button'); r.type = 'button'; r.className = 'lay-form'; r.setAttribute('role', 'radio'); r.setAttribute('aria-checked', String(an)); r.disabled = b.disabled;
        r.innerHTML = '<img alt="" ' + (info.url ? 'src="' + info.url + '"' : '') + ' onerror="this.style.visibility=\'hidden\'">' +
          '<span><b>' + name.replace(/</g, '&lt;') + '</b>' + (info.masse ? '<small>' + info.masse.replace(/</g, '&lt;') + '</small>' : '') + '</span>' +
          '<span class="lay-form-preis">' + preis.replace(/</g, '&lt;') + '</span>';
        r.addEventListener('click', function () { if (!an) { b.click(); melde('dock_form', name, root); } });
        w.appendChild(r);
        if (an) {
          w.appendChild(opts);
          // Eine Achse, auf der nichts wählbar ist (alle Knöpfe gesperrt), sagt nichts — weg damit.
          [].forEach.call(opts.children, function (g) {
            var k = [].slice.call(g.querySelectorAll('.fmnv-p3d__cfg'));
            g.classList.toggle('lay-leer', !k.length || k.every(function (x) { return x.disabled; }));
          });
          var sichtbar = [].slice.call(opts.children).some(function (g) { return !g.hidden && !g.classList.contains('lay-leer'); });
          opts.hidden = !sichtbar;
        }
        liste.appendChild(w);
      });
    }
    new MutationObserver(bauen).observe(axis, { childList: true });
    if (seite) new MutationObserver(bauen).observe(seite, { attributes: true, attributeFilter: ['hidden'] });
    if (sleep) new MutationObserver(bauen).observe(sleep, { childList: true, subtree: true, attributeFilter: ['hidden', 'class'] });
    bauen();
  }

  /* Wischen im Viewer blättert (Marc, 2026-10-06): Eine entschlossene waagerechte
     Geste — weit und schnell, kaum senkrechter Anteil — geht zum nächsten bzw.
     vorigen Bild (dieselben Knöpfe wie die Pfeile). Kurze oder langsame Bewegungen
     bleiben beim Drehen des Modells. */
  function wischen(root) {
    var stage = root.querySelector('.fmnv-p3d__stage');
    if (!stage) return;
    var start = null;
    stage.addEventListener('pointerdown', function (e) {
      // Im Modell-Schritt gibt es keine Galerie — dort dreht Wischen nur das Sofa.
      if (e.pointerType === 'mouse' || root.dataset.mobileStep === '1' || e.target.closest('button, a, .fmnv-p3d__thumbs, .fmnv-p3d__tabs, .fmnv-p3d__ecke')) { start = null; return; }
      start = { x: e.clientX, y: e.clientY, t: e.timeStamp };
    }, true);
    function ende(e) {
      if (!start) return;
      var dx = e.clientX - start.x, dy = e.clientY - start.y, dt = e.timeStamp - start.t;
      start = null;
      if (Math.abs(dx) < 80 || Math.abs(dx) < 1.6 * Math.abs(dy) || dt > 600) return;
      var knopf = root.querySelector('[data-p3d-rotate="' + (dx < 0 ? '1' : '-1') + '"]');
      if (knopf) { knopf.click(); melde('dock_wischen', dx < 0 ? 'weiter' : 'zurueck', root); }
    }
    stage.addEventListener('pointerup', ende, true);
    stage.addEventListener('pointercancel', ende, true);
  }

  /* Desktop (Marc, 2026-10-08): Pille „Modell / Stoff & Farbe“ und Herz im Viewer,
     Titel oben im Panel. Im Schritt „Modell“ zwei statt drei Spalten — die
     Stoffspalte wird zur kleinen Karte unten rechts im Viewer —, Formen als Karten
     (wie mobil) und alle Maße als Tabelle. Hover über eine Form zeigt sie im Viewer,
     gewählt wird erst per Klick. CSS: html.fmnv-lay-d in fmnv-p3d-layouts.css. */
  function deskStart(root) {
    html.classList.add('fmnv-lay-d');
    var panel = root.querySelector('.fmnv-p3d__panel');
    var vm = root.querySelector('.fmnv-p3d__viewer-main');
    var head = root.querySelector('.fmnv-p3d__head');
    var tabs = root.querySelector('[data-p3d-tabs]');
    var step1 = root.querySelector('[data-p3d-step="1"]');
    if (head && panel) panel.insertBefore(head, panel.firstChild);
    // Reiter rechts über dem Titel statt im Bild (Marc, 2026-10-20).
    if (tabs && head) head.insertBefore(tabs, head.firstChild);
    /* Mausrad scrollt die Seite statt zu zoomen: Der große Viewer fing sonst fast jede
       Scrollbewegung ab (Marc, 2026-10-08). Gezoomt wird über + / −. */
    var mvEl = root.querySelector('model-viewer'); if (mvEl) mvEl.setAttribute('disable-zoom', '');

    // Stoff als Karte im Viewer; Quelle ist die Stoffspalte, die im Modell-Schritt ausgeblendet ist.
    var prev = root.querySelector('[data-p3d-preview]');
    var stoff = document.createElement('button'); stoff.type = 'button'; stoff.className = 'lay-d-stoff';
    stoff.innerHTML = '<span class="lay-d-sw"></span><span><small>Dein Stoff</small><b></b><em>ändern</em></span>';
    if (vm) vm.appendChild(stoff);
    function stoffSync() {
      var fam = (root.querySelector('[data-p3d-current-family]') || {}).textContent || '';
      var farbe = (root.querySelector('[data-p3d-preview-name]') || {}).textContent || '';
      fam = fam.trim(); farbe = farbe.trim();
      if (farbe.toLowerCase().indexOf(fam.toLowerCase()) === 0) farbe = farbe.slice(fam.length).trim();
      stoff.querySelector('b').textContent = fam ? fam + (farbe ? ' · ' + farbe.charAt(0) + farbe.slice(1).toLowerCase() : '') : '';
      stoff.querySelector('.lay-d-sw').style.backgroundImage = prev ? prev.style.backgroundImage : '';
      stoff.hidden = !fam;
    }
    stoff.addEventListener('click', function () {
      var t = root.querySelector('.fmnv-p3d__tab[data-nr="2"]:not([disabled])'); if (t) t.click();
      melde('desk_stoff_karte', '', root);
    });
    if (prev) new MutationObserver(stoffSync).observe(prev, { attributes: true, attributeFilter: ['style'] });
    var fn = root.querySelector('.fmnv-p3d__preview-foot'); if (fn) new MutationObserver(stoffSync).observe(fn, { childList: true, characterData: true, subtree: true });
    stoffSync();

    function schritt() { root.classList.toggle('lay-d-m', !!step1 && step1.classList.contains('is-open')); }
    if (step1) new MutationObserver(schritt).observe(step1, { attributes: true, attributeFilter: ['class'] });
    schritt();

    // Maße als Tabelle; die längste Bezeichnung passt so in eine Zelle.
    var box = root.querySelector('[data-p3d-specbox]');
    function kurz() { [].forEach.call(box.querySelectorAll('dt'), function (d) { if (d.textContent === 'Höhe mit Kopfteil oben') d.textContent = 'Höhe inkl. Kopfteil'; }); }
    if (box) { new MutationObserver(kurz).observe(box, { childList: true }); kurz(); }

    modell(root);

    /* Karten so groß, wie es ohne Scrollen ins Panel passt (Marc, 2026-10-08: „unnötig
       gequetscht“); nur bei vielen Formen und niedrigem Fenster bleiben sie kompakt. */
    var steps = root.querySelector('.fmnv-p3d__steps');
    function weit() {
      if (!steps) return;
      // Größte Stufe, die ohne Scrollen passt: weit → mittel → kompakt.
      root.classList.remove('lay-d-mittel'); root.classList.add('lay-d-weit');
      if (steps.scrollHeight <= steps.clientHeight + 1) return;
      root.classList.remove('lay-d-weit'); root.classList.add('lay-d-mittel');
      if (steps.scrollHeight > steps.clientHeight + 1) root.classList.remove('lay-d-mittel');
    }
    var formen = root.querySelector('.lay-formen');
    if (formen) new MutationObserver(weit).observe(formen, { childList: true, subtree: true });
    addEventListener('resize', weit);
    if (step1) new MutationObserver(weit).observe(step1, { attributes: true, attributeFilter: ['class'] });
    weit();

    // Vorschau beim Überfahren: das Vorschaubild der Form über dem Modell.
    var liste = root.querySelector('.lay-formen');
    var peek = document.createElement('div'); peek.className = 'lay-d-peek'; peek.hidden = true;
    peek.innerHTML = '<span></span><img alt="">';
    if (vm) vm.appendChild(peek);
    if (liste) {
      liste.addEventListener('mouseover', function (e) {
        var f = e.target.closest('.lay-form');
        if (!f || f.getAttribute('aria-checked') === 'true' || f.disabled) { peek.hidden = true; return; }
        var img = f.querySelector('img');
        if (!img || !img.src || img.style.visibility === 'hidden') { peek.hidden = true; return; }
        peek.querySelector('img').src = img.src;
        peek.querySelector('span').textContent = 'Vorschau: ' + (f.querySelector('b') || {}).textContent;
        peek.hidden = false;
      });
      liste.addEventListener('mouseleave', function () { peek.hidden = true; });
      liste.addEventListener('click', function () { peek.hidden = true; });
    }
  }
  function deskWarte() {
    var r = document.querySelector('.fmnv-p3d');
    if (!r) return;
    // Erst wenn der Konfigurator offen ist: Das Schaufenster davor bleibt unverändert.
    function bereit() { return !r.classList.contains('ist-showroom') && r.querySelector('[data-p3d-axis-size] .fmnv-p3d__cfg'); }
    if (bereit()) return deskStart(r);
    var mo = new MutationObserver(function () { if (bereit()) { mo.disconnect(); deskStart(r); } });
    mo.observe(r, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
  }

  /* Der Mobil-Arbeitsbereich entsteht erst, wenn das Konfigurator-Modul geladen ist. */
  function warte() {
    var root = document.querySelector('.fmnv-p3d.is-mobile-workspace');
    if (root) return start(root);
    var n = 0, t = setInterval(function () {
      var r = document.querySelector('.fmnv-p3d.is-mobile-workspace');
      if (r) { clearInterval(t); start(r); } else if (++n > 80) clearInterval(t);
    }, 150);
  }
  if (document.readyState !== 'loading') warte(); else document.addEventListener('DOMContentLoaded', warte);
})();
